import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { isAreaSelectedChecker } from '../../utils'
import ChildAreaBox from '../ChildAreaBox'
import { _ChildrenContainer } from './styles'


const sortArea = (a, b) => {
  if(a.label > b.label) return 1
  if(a.label < b.label) return -1
  return 0
}

const SortedAreaBoxList = (
  {
    lcaMapTree,
    rootArea,
    lastSearchObj,
    lookups,
    showListActive,
    onHover,
    googleAnalyticsEvent,
    calculateLcaAndSelectedAreas,
  }) => {
  // making sure sort happen only showListActive updates
  const sortedArea = useMemo(() => {
    if(!showListActive) return null
    return rootArea && rootArea.children
      .map(child => lcaMapTree[child])
      .sort(sortArea)
  }, [showListActive, rootArea, lcaMapTree])

  function renderChildren() {
    if(sortedArea) {
      // sort children area in the collapsible
      const sortedAreaBoxComp = sortedArea
        .map(childArea => {
          const isSelected = isAreaSelectedChecker(childArea, lastSearchObj, lookups)
          return (
            <ChildAreaBox
              key={'collapsibleChildBox' + (childArea && childArea.areaId)}
              area={childArea}
              isSelected={isSelected}
              onHover={() => { onHover(childArea) }}
              onMouseLeave={() => { onHover(null) }}
              onClick={(e) => {
                e.stopPropagation()
                googleAnalyticsEvent({
                  category: 'search',
                  action: [
                    'Discovery area collapsible children area click',
                    isSelected ? 'deselect' : 'select',
                    childArea.areaType,
                  ],
                })
                calculateLcaAndSelectedAreas(`${childArea.areaType}_${childArea.areaId}`, isSelected)
              }}
            />
          )
        })
      return <_ChildrenContainer>{sortedAreaBoxComp}</_ChildrenContainer>
    }
    return null
  }
  return useMemo(
    () => renderChildren(),
    [showListActive, lastSearchObj, lookups])
}
SortedAreaBoxList.propTypes = {
  rootArea: PropTypes.shape({
    areaType: PropTypes.string,
    areaId: PropTypes.number,
    label: PropTypes.string,
    filterType: PropTypes.string,
    children: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  lookups: PropTypes.shape({
    id: PropTypes.number,
  }),
  calculateLcaAndSelectedAreas: PropTypes.func,
  onHover: PropTypes.func,
  googleAnalyticsEvent: PropTypes.func,
  showListActive: PropTypes.bool,
  lcaMapTree: PropTypes.shape({}),
  lastSearchObj: PropTypes.shape({}),
}

export default SortedAreaBoxList
